import { useEffect, useMemo } from "react";
import { rootActions } from "../state/actions/rootActions";
import { eReducerStatusBase } from "../state/reducer-model/eReducerStatusBase";
import { useAppDispatch } from "./useAppDispatch";
import { useAppSelector } from "./useAppSelector";
import { IDmHe } from "../model/respone/category/IDmHe";

export const useHe = () => {
  const state = useAppSelector((x) => x.category.he);
  const { status, hes } = state;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (
      status === eReducerStatusBase.is_not_initialization ||
      status === eReducerStatusBase.is_need_reload
    ) {
      dispatch(rootActions.category.he.LOAD_START(undefined));
    }
  }, [dispatch, status]);
  const heMap = useMemo(() => {
    const _map = new Map<number, IDmHe>();
    hes.forEach(h => {
      _map.set(h.id_he, h)
    })
    return _map;
  }, [hes]);
  return {
    ...state,
    hes,
    isLoading: status === eReducerStatusBase.is_loading,
    heMap,
  };
};
